<template>
  <b-container class="page-autor-public" :fluid="windowWidth < 762">
    <!-- header -->
    <b-row>
      <b-col cols="12">
        <section class="d-flex flex-column flex-md-row text-center text-md-start">
          <aside class="flex-grow-0 flex-shrink-0 d-flex justify-content-center align-items-center px-1">
            <avatar :name="autor.full_name" color="#35656f" :size="150" :src="autor.avatar" />
          </aside>
          <main class="d-flex flex-column flex-grow-1 w-100 p-1">
            <strong class="fs-1 fw-bolder my-0  lh-0 ">{{ autor.full_name }}</strong>
            <section>
              <font-awesome-icon icon="fas fa-envelope" />
              Email: <a :href="`mailto:${autor.email}`" target="_blank">{{ autor.email }}</a>
            </section>
            <section v-if="autor.libros_publicados">
              <font-awesome-icon icon="fas fa-book" />
              Libros publicados: {{ autor.libros_publicados.length > 1 ? autor.libros_publicados.length + ' libros' :
              autor.libros_publicados.length + ' libro' }}
            </section>
          </main>
        </section>
      </b-col>
      <b-col cols="12" md="8">

      </b-col>
    </b-row>
    <!-- main -->
    <b-row v-if="autor.sinopsis_general">
      <b-col cols="12" class="mt-1">
        <h3 class="fs-1">Sinopsis del Autor</h3>
        <p v-html="autor.sinopsis_general" class="text-start fs-4 text-muted lh-base">
        </p>
      </b-col>
    </b-row>
    <!-- Libros por el Autor -->
    <b-row>
      <b-col cols="12">
        <h3 class="fs-1">Libros publicados</h3>

        <section class="libros-publicados" v-if="autor.libros_publicados && autor.libros_publicados.length">
          <template v-for="bio in autor.libros_publicados" :key="bio.id">
            <bio-publicada :bio="bio" :autor="autor" @mostrar-visor="mostrarVisor" />
          </template>
        </section>

        <section class="no-data d-flex w-100 flex-column align-items-center justify-content-center mt-2"
          v-else>
          <font-awesome-icon icon="fas fa-clipboard-list" size="3x" />
          <h2 class="text-center">No hay Biografías</h2>
          <p class="text-center">El Autor <strong class="text-primary fs-5 fst-bold">{{ autor.full_name }}</strong> no ha publicado nínguna Biografía </p>
        </section>

      </b-col>

    </b-row>

    <visor-pdf v-model="showVisorPdf" :url="urlPdf" titulo="Ebook" />

  </b-container>
</template>

<script setup>
import VisorPdf from 'components/VisorPdf.vue';

import avatar from '@components/avatar.vue';
import BioPublicada from 'components/BioPublicada.vue'

import useUtils from '@composables/useUtils';

const autor = defineModel({
  type:Object,
  default: () => ({
    id:null,
    full_name: '',
    email: '',
    avatar: '',
    sinopsis_general: '',
    libros_publicados: []
  })
});

const {
  windowWidth
} = useUtils();

const showVisorPdf = ref(false);
const urlPdf = ref('');

const mostrarVisor = (url) => {
  urlPdf.value = url;
  showVisorPdf.value = true;
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/variables/variables" as *;

.page-autor-public {
  flex: 1 1 90%;
  color: $dark;
  overflow-y: scroll;

  .libros-publicados {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

}


</style>